import { Box } from '@/components/box/box';
import { focusStateStyles, underlineHoverStyles } from '../underline/underline';
import { styled } from '@/stitches.config';

type MoreButtonProps = {
  children: React.ReactNode;
  handleClick: () => void;
};

export function MoreButton({ children, handleClick }: MoreButtonProps) {
  return (
    <Box
      css={{
        gridColumn: '7 / span 11',
        '@bp5': {
          gridColumn: '6 / span 12',
        },
      }}
    >
      <Button onClick={handleClick}>
        {children}
        <Under />
        <UnderIcon />
      </Button>
    </Box>
  );
}

const TEXT_UNDERLINE_WIDTH = `calc(100% - 20px)`;

const Under = styled('div', {
  display: 'block',
  position: 'absolute',
  height: '4px',
  left: 0,
  bottom: '-4px',
  width: TEXT_UNDERLINE_WIDTH,
  pointerEvents: 'none',
  background: 'currentColor',

  transition: 'transform',
});

const UnderIcon = styled('div', {
  position: 'absolute',
  display: 'block',
  height: '4px',
  right: 0, // visually realign to the right side of the icon
  bottom: '-4px',
  width: '20px',
  pointerEvents: 'none',
  background: 'currentColor',

  transition: 'transform',
  animationDelay: '80ms',
});

const Button = styled('button', {
  all: 'unset',
  color: '$foreground',
  fontSize: '$3',
  position: 'relative',
  whiteSpace: 'nowrap',
  cursor: 'pointer',
  marginTop: '$7',
  display: 'flex',
  alignItems: 'center',
  overflow: 'hidden',

  // adds safe space around button for click interaction
  '&:after': {
    position: 'absolute',
    content: '',
    display: 'block',
    width: 'calc(100% + 10px)',
    height: 'calc(100% + 10px)',
    top: '-5px',
    left: '-5px',
  },

  svg: {
    paddingRight: '$1',
  },

  '&:hover, &:active': {
    [`${Under}, ${UnderIcon}`]: underlineHoverStyles,
  },

  '&:focus-visible': {
    ...focusStateStyles,
    outlineOffset: '2px',

    [`${Under}, ${UnderIcon}`]: underlineHoverStyles,
  },
});
